import { constants } from './constants'

const loadInit = orderId => ({
  type: constants.LOAD_INIT,
  payload: {
    orderId,
  },
})

const loadSucceeded = () => ({
  type: constants.LOAD_SUCCEEDED,
})

const loadFailed = error => ({
  type: constants.LOAD_FAILED,
  payload: error,
})

export const actions = {
  loadInit,
  loadSucceeded,
  loadFailed,
}
